module.exports = __webpack_public_path__ + "img/emoji-sunglasses-fill.f60f87ff.svg";